var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15C19.5 14.5858 19.1642 14.25 18.75 14.25C18.3358 14.25 18 14.5858 18 15H19.5ZM18 30C18 30.4142 18.3358 30.75 18.75 30.75C19.1642 30.75 19.5 30.4142 19.5 30H18ZM18 15V30H19.5V15H18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 15C27 14.5858 26.6642 14.25 26.25 14.25C25.8358 14.25 25.5 14.5858 25.5 15H27ZM25.5 30C25.5 30.4142 25.8358 30.75 26.25 30.75C26.6642 30.75 27 30.4142 27 30H25.5ZM25.5 15V30H27V15H25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.375 22.5C39.375 31.8198 31.8198 39.375 22.5 39.375C13.1802 39.375 5.625 31.8198 5.625 22.5C5.625 13.1802 13.1802 5.625 22.5 5.625C31.8198 5.625 39.375 13.1802 39.375 22.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.dd48ca2f.svg";
export { ForwardRef as ReactComponent };